import { render, staticRenderFns } from "./ChangementProprietaire.vue?vue&type=template&id=5d298c5a&"
import script from "./ChangementProprietaire.vue?vue&type=script&lang=js&"
export * from "./ChangementProprietaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports